"use strict";

theme.initQuickShop = function () {
  var ids = [];
  var products = document.querySelectorAll(".grid-product");

  if (!products.length || !theme.settings.quickView) {
    return;
  }

  products.forEach((product) => {
    product.addEventListener("mouseover", productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    // No quick view on mobile breakpoint
    if (!theme.config.bpSmall) {
      el.removeEventListener("mouseover", productMouseover);
      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var handle = el.dataset.productHandle;
      var btn = el.querySelector(".quick-product__btn");
      theme.preloadProductModal(handle, productId, btn);
    }
  }
};

theme.preloadProductModal = function (handle, productId, btn) {
  var holder = document.getElementById("QuickShopHolder-" + handle);
  var url = theme.routes.home + "/products/" + handle + "?view=modal";

  // remove double `/` in case shop might have /en or language in URL
  url = url.replace("//", "/");

  fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var div = doc.querySelector(
        '.product-section[data-product-handle="' + handle + '"]',
      );

      if (!holder) {
        return;
      }

      holder.innerHTML = "";
      holder.append(div);

      // Make sure the freshly-injected gallery images actually load
      theme.lazyImages();

      // Setup quick view modal
      var modalId = "QuickShopModal-" + productId;
      var name = "quick-modal-" + productId;
      new theme.Modals(modalId, name);

      // Register product template inside quick view
      theme.sections.register("product", theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove("quick-product__btn--not-ready");
      }
    });
};

// theme.Slideshow handles all flickity based sliders
// Child navigation is only setup to work on product images
theme.Product = (function () {
  var videoObjects = {};

  var classes = {
    onSale: "on-sale",
    disabled: "disabled",
    isModal: "is-modal",
    loading: "loading",
    loaded: "loaded",
    hidden: "hide",
    interactable: "video-interactable",
    visuallyHide: "visually-invisible",
  };

  var selectors = {
    productVideo: ".product__video",
    videoParent: ".product__video-wrapper",
    slide: ".product-main-slide",
    currentSlide: ".is-selected",
    startingSlide: ".starting-slide",
    variantType: ".variant-wrapper",
    blocks: "[data-product-blocks]",
    blocksHolder: "[data-blocks-holder]",
  };

  function Product(container) {
    this.container = container;
    var sectionId = (this.sectionId =
      container.getAttribute("data-section-id"));
    var productId = (this.productId =
      container.getAttribute("data-product-id"));

    this.inModal = container.dataset.modal === "true";
    this.modal;

    this.settings = {
      enableHistoryState: container.dataset.history || false,
      namespace: ".product-" + sectionId,
      inventory: false,
      inventoryThreshold: 10,
      modalInit: false,
      hasImages: true,
      imageSetName: null,
      imageSetIndex: null,
      currentImageSet: null,
      imageSize: "620x",
      currentSlideIndex: 0,
      videoLooping: container.dataset.videoLooping,
    };

    // Overwrite some settings when loaded in modal
    if (this.inModal) {
      this.settings.enableHistoryState = false;
      this.settings.namespace = ".product-" + sectionId + "-modal";
      this.modal = document.getElementById("QuickShopModal-" + productId);
    }

    this.selectors = {
      variantsJson: "[data-variant-json]",
      currentVariantJson: "[data-current-variant-json]",
      form: ".product-single__form",

      media: "[data-product-media-type-model]",
      closeMedia: ".product-single__close-media",
      photoThumbs: "[data-product-thumb]",
      thumbSlider: "[data-product-thumbs]",
      thumbScroller: ".product__thumbs--scroller",
      mainSlider: "[data-product-photos]",
      imageContainer: "[data-product-images]",
      productImageMain: "[data-product-image-main]",

      priceWrapper: "[data-product-price-wrap]",
      price: "[data-product-price]",
      comparePrice: "[data-compare-price]",
      savePrice: "[data-save-price]",
      priceA11y: "[data-a11y-price]",
      comparePriceA11y: "[data-compare-price-a11y]",
      unitWrapper: "[data-unit-price-wrapper]",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-base]",
      sku: "[data-sku]",
      inventory: "[data-product-inventory]",
      incomingInventory: "[data-incoming-inventory]",
      colorLabel: "[data-variant-color-label]",

      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",

      originalSelectorId: "[data-product-select]",
      singleOptionSelector: "[data-variant-input]",
      variantColorSwatch: ".variant__input--color-swatch",

      availabilityContainer: "[data-store-availability-holder]",
    };

    this.cacheElements();

    this.firstProductImage = this.cache.mainSlider.querySelector("img");

    if (!this.firstProductImage) {
      this.settings.hasImages = false;
    }

    var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
    if (dataSetEl) {
      this.settings.imageSetName = dataSetEl.dataset.setName;
    }

    this.init();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function () {
      if (this.inModal) {
        this.container.classList.add(classes.isModal);
        document.addEventListener(
          "modalOpen.QuickShopModal-" + this.productId,
          this.openModalProduct.bind(this),
        );
        document.addEventListener(
          "modalClose.QuickShopModal-" + this.productId,
          this.closeModalProduct.bind(this),
        );
      }

      if (!this.inModal) {
        this.formSetup();
        this.productSetup();
        this.videoSetup();
        this.initProductSlider();
        this.customMediaListners();
        this.addIdToRecentlyViewed();
      }
    },

    cacheElements: function () {
      this.cache = {
        form: this.container.querySelector(this.selectors.form),
        mainSlider: this.container.querySelector(this.selectors.mainSlider),
        thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
        thumbScroller: this.container.querySelector(
          this.selectors.thumbScroller,
        ),
        productImageMain: this.container.querySelector(
          this.selectors.productImageMain,
        ),

        // Price-related
        priceWrapper: this.container.querySelector(
          this.selectors.priceWrapper,
        ),
        comparePriceA11y: this.container.querySelector(
          this.selectors.comparePriceA11y,
        ),
        comparePrice: this.container.querySelector(
          this.selectors.comparePrice,
        ),
        price: this.container.querySelector(this.selectors.price),
        savePrice: this.container.querySelector(this.selectors.savePrice),
        priceA11y: this.container.querySelector(this.selectors.priceA11y),
      };
    },

    formSetup: function () {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.availabilitySetup();
      this.initVariants();

      // We know the current variant now so setup image sets
      if (this.settings.imageSetName) {
        this.updateImageSet();
      }
    },

    availabilitySetup: function () {
      var container = this.container.querySelector(
        this.selectors.availabilityContainer,
      );
      if (container) {
        this.storeAvailability = new theme.StoreAvailability(container);
      }
    },

    productSetup: function () {
      this.setImageSizes();
      this.initImageZoom();
      this.initModelViewerLibraries();
      this.initShopifyXrLaunch();

      if (window.SPR) {
        SPR.initDomEls();
        SPR.loadBadges();
      }
    },

    setImageSizes: function () {
      if (!this.settings.hasImages) {
        return;
      }

      // Get srcset image src, works on most modern browsers
      // otherwise defaults to settings.imageSize
      var currentImage = this.firstProductImage.currentSrc;

      if (currentImage) {
        this.settings.imageSize = theme.Images.imageSize(currentImage);
      }
    },

    addIdToRecentlyViewed: function () {
      var handle = this.container.getAttribute("data-product-handle");
      var url = this.container.getAttribute("data-product-url");
      var aspectRatio = this.container.getAttribute("data-aspect-ratio");
      var featuredImage = this.container.getAttribute("data-img-url");

      // Remove current product if already in set of recent
      if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
        delete theme.recentlyViewed.recent[handle];
      }

      // Add it back to the end
      theme.recentlyViewed.recent[handle] = {
        url: url,
        aspectRatio: aspectRatio,
        featuredImage: featuredImage,
      };

      if (theme.config.hasLocalStorage) {
        window.localStorage.setItem(
          "theme-recent",
          JSON.stringify(theme.recentlyViewed.recent),
        );
      }
    },

    initVariants: function () {
      var variantJson = this.container.querySelector(
        this.selectors.variantsJson,
      );

      if (!variantJson) {
        return;
      }

      this.variantsObject = JSON.parse(variantJson.innerHTML);

      var options = {
        container: this.container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        variants: this.variantsObject,
      };

      var swatches = this.container.querySelectorAll(
        this.selectors.variantColorSwatch,
      );
      if (swatches.length) {
        swatches.forEach((swatch) => {
          swatch.addEventListener(
            "change",
            function (evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this),
          );
        });
      }

      this.variants = new theme.Variants(options);

      // Product availability on page load
      if (this.storeAvailability) {
        var variant_id = this.variants.currentVariant
          ? this.variants.currentVariant.id
          : this.variants.variants[0].id;

        this.storeAvailability.updateContent(variant_id);
        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateAvailability.bind(this),
        );
      }

      this.container.on(
        "variantChange" + this.settings.namespace,
        this.updateCartButton.bind(this),
      );
      this.container.on(
        "variantImageChange" + this.settings.namespace,
        this.updateVariantImage.bind(this),
      );
      this.container.on(
        "variantPriceChange" + this.settings.namespace,
        this.updatePrice.bind(this),
      );
      this.container.on(
        "variantUnitPriceChange" + this.settings.namespace,
        this.updateUnitPrice.bind(this),
      );

      if (this.container.querySelector(this.selectors.sku)) {
        this.container.on(
          "variantSKUChange" + this.settings.namespace,
          this.updateSku.bind(this),
        );
      }

      var inventoryEl = this.container.querySelector(
        this.selectors.inventory,
      );
      if (inventoryEl) {
        this.settings.inventory = true;
        this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateInventory.bind(this),
        );
      }

      // Update individual variant availability on each selection
      if (theme.settings.dynamicVariantsEnable) {
        var currentVariantJson = this.container.querySelector(
          this.selectors.currentVariantJson,
        );

        if (currentVariantJson) {
          var variantType = this.container.querySelector(
            selectors.variantType,
          );

          if (variantType) {
            new theme.VariantAvailability({
              container: this.container,
              namespace: this.settings.namespace,
              type: variantType.dataset.type,
              variantsObject: this.variantsObject,
              currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
            });
          }
        }
      }

      // image set names variant change listeners
      if (this.settings.imageSetName) {
        var variantWrapper = this.container.querySelector(
          '.variant-input-wrap[data-handle="' +
            this.settings.imageSetName +
            '"]',
        );
        if (variantWrapper) {
          this.settings.imageSetIndex = variantWrapper.dataset.index;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateImageSet.bind(this),
          );
        } else {
          this.settings.imageSetName = null;
        }
      }
    },

    initQtySelector: function () {
      this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
        new theme.QtySelector(el, {
          namespace: ".product",
        });
      });
    },

    initAjaxProductForm: function () {
      if (theme.settings.cartType === "drawer") {
        new theme.AjaxProduct(this.cache.form);
      }
    },

    /*============================================================================
      Variant change methods
    ==============================================================================*/
    updateColorName: function (color, index) {
      // Updates on radio button change, not variant.js
      this.container.querySelector(
        this.selectors.colorLabel + `[data-index="${index}"`,
      ).textContent = color;
    },

    updateCartButton: function (evt) {
      var variant = evt.detail.variant;
      var cartBtn = this.container.querySelector(this.selectors.addToCart);
      var cartBtnText = this.container.querySelector(
        this.selectors.addToCartText,
      );

      if (variant) {
        if (variant.available) {
          // Available, enable the submit button and change text
          cartBtn.classList.remove(classes.disabled);
          cartBtn.disabled = false;
          var defaultText = cartBtnText.dataset.defaultText;
          cartBtnText.textContent = defaultText;
        } else {
          // Sold out, disable the submit button and change text
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.soldOut;
        }
      } else {
        // The variant doesn't exist, disable submit button
        cartBtn.classList.add(classes.disabled);
        cartBtn.disabled = true;
        cartBtnText.textContent = theme.strings.unavailable;
      }
    },

    updatePrice: function (evt) {
      var variant = evt.detail.variant;

      if (variant) {
        // Regular price
        this.cache.price.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.settings.moneyFormat,
        );

        // Sale price, if necessary
        if (variant.compare_at_price > variant.price) {
          this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.settings.moneyFormat,
          );
          this.cache.priceWrapper.classList.remove(classes.hidden);
          this.cache.price.classList.add(classes.onSale);
          this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
          this.cache.priceA11y.setAttribute("aria-hidden", "false");

          var savings = variant.compare_at_price - variant.price;

          if (theme.settings.saveType == "percent") {
            savings =
              Math.round((savings * 100) / variant.compare_at_price) + "%";
          } else {
            savings = theme.Currency.formatMoney(
              savings,
              theme.settings.moneyFormat,
            );
          }

          this.cache.savePrice.classList.remove(classes.hidden);
          this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
            "[saved_amount]",
            savings,
          );
        } else {
          if (this.cache.priceWrapper) {
            this.cache.priceWrapper.classList.add(classes.hidden);
          }
          this.cache.savePrice.classList.add(classes.hidden);
          this.cache.price.classList.remove(classes.onSale);
          if (this.cache.comparePriceA11y) {
            this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
          }
          this.cache.priceA11y.setAttribute("aria-hidden", "true");
        }
      }
    },

    updateUnitPrice: function (evt) {
      var variant = evt.detail.variant;

      if (variant && variant.unit_price) {
        this.container.querySelector(this.selectors.unitPrice).innerHTML =
          theme.Currency.formatMoney(
            variant.unit_price,
            theme.settings.moneyFormat,
          );
        this.container.querySelector(
          this.selectors.unitPriceBaseUnit,
        ).innerHTML = theme.Currency.getBaseUnit(variant);
        this.container
          .querySelector(this.selectors.unitWrapper)
          .classList.remove(classes.hidden);
      } else {
        this.container
          .querySelector(this.selectors.unitWrapper)
          .classList.add(classes.hidden);
      }
    },

    imageSetArguments: function (variant) {
      var variant = variant
        ? variant
        : this.variants
          ? this.variants.currentVariant
          : null;
      if (!variant) return;

      var setValue = (this.settings.currentImageSet = this.getImageSetName(
        variant[this.settings.imageSetIndex],
      ));
      var set = this.settings.imageSetName + "_" + setValue;

      // Always start on index 0
      this.settings.currentSlideIndex = 0;

      // Return object that adds cellSelector to mainSliderArgs
      return {
        cellSelector: '[data-group="' + set + '"]',
        imageSet: set,
        initialIndex: this.settings.currentSlideIndex,
      };
    },

    updateImageSet: function (evt) {
      // If called directly, use current variant
      var variant = evt
        ? evt.detail.variant
        : this.variants
          ? this.variants.currentVariant
          : null;
      if (!variant) {
        return;
      }

      var setValue = this.getImageSetName(
        variant[this.settings.imageSetIndex],
      );

      // Already on the current image group
      if (this.settings.currentImageSet === setValue) {
        return;
      }

      this.initProductSlider(variant);
    },

    // Show/hide thumbnails based on current image set
    updateImageSetThumbs: function (set) {
      this.cache.thumbSlider
        .querySelectorAll(".product__thumb-item")
        .forEach((thumb) => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
    },

    getImageSetName: function (string) {
      return string
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    },

    updateSku: function (evt) {
      var variant = evt.detail.variant;
      var newSku = "";

      if (variant) {
        if (variant.sku) {
          newSku = variant.sku;
        }

        this.container.querySelector(this.selectors.sku).textContent = newSku;
      }
    },

    updateInventory: function (evt) {
      var variant = evt.detail.variant;

      // Hide stock if no inventory management or policy is continue
      if (
        !variant ||
        !variant.inventory_management ||
        variant.inventory_policy === "continue"
      ) {
        this.toggleInventoryQuantity(variant, false);
        this.toggleIncomingInventory(false);
        return;
      }

      if (
        variant.inventory_management === "shopify" &&
        window.inventories &&
        window.inventories[this.productId]
      ) {
        var variantInventoryObject =
          window.inventories[this.productId][variant.id];

        // Hide stock if policy is continue
        if (variantInventoryObject.policy === "continue") {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        var quantity = variantInventoryObject.quantity;
        var showInventory = true;
        var showIncomingInventory = false;

        if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
          showInventory = false;
        }

        this.toggleInventoryQuantity(variant, showInventory, quantity);

        // Only show incoming inventory when:
        // - inventory notice itself is hidden
        // - have incoming inventory
        // - current quantity is below theme setting threshold
        if (
          !showInventory &&
          variantInventoryObject.incoming === "true" &&
          quantity <= this.settings.inventoryThreshold
        ) {
          showIncomingInventory = true;
        }

        this.toggleIncomingInventory(
          showIncomingInventory,
          variant.available,
          variantInventoryObject.next_incoming_date,
        );
      }
    },

    updateAvailability: function (evt) {
      var variant = evt.detail.variant;
      if (!variant) {
        return;
      }

      this.storeAvailability.updateContent(variant.id);
    },

    toggleInventoryQuantity: function (variant, show, qty) {
      if (!this.settings.inventory) {
        show = false;
      }

      var el = this.container.querySelector(this.selectors.inventory);
      var salesPoint = el.closest(".product-block");

      if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
        el.parentNode.classList.add("inventory--low");
        el.textContent = theme.strings.stockLabel.replace("[count]", qty);
      } else {
        el.parentNode.classList.remove("inventory--low");
        el.textContent = theme.strings.inStockLabel;
      }

      if (variant && variant.available) {
        el.parentNode.classList.remove(classes.hidden);
        if (salesPoint) {
          salesPoint.classList.remove(classes.hidden);
        }
      } else {
        el.parentNode.classList.add(classes.hidden);
        if (salesPoint) {
          salesPoint.classList.add(classes.hidden);
        }
      }
    },

    toggleIncomingInventory: function (show, available, date) {
      var el = this.container.querySelector(this.selectors.incomingInventory);
      var salesPoint = el.closest(".product-block");

      if (!el) {
        return;
      }

      var textEl = el.querySelector(".js-incoming-text");

      if (show) {
        var string = available
          ? theme.strings.willNotShipUntil.replace("[date]", date)
          : theme.strings.willBeInStockAfter.replace("[date]", date);

        if (!date) {
          string = theme.strings.waitingForStock;
        }

        el.classList.remove(classes.hidden);
        if (salesPoint) {
          salesPoint.classList.remove(classes.hidden);
        }
        textEl.textContent = string;
      } else {
        el.classList.add(classes.hidden);
      }
    },

    /*============================================================================
      Product videos
    ==============================================================================*/
    videoSetup: function () {
      var productVideos = this.cache.mainSlider.querySelectorAll(
        selectors.productVideo,
      );

      if (!productVideos.length) {
        return false;
      }

      productVideos.forEach((vid) => {
        var type = vid.dataset.videoType;
        if (type === "youtube") {
          this.initYoutubeVideo(vid);
        } else if (type === "mp4") {
          this.initMp4Video(vid);
        }
      });
    },

    initYoutubeVideo: function (div) {
      videoObjects[div.id] = new theme.YouTube(div.id, {
        videoId: div.dataset.youtubeId,
        videoParent: selectors.videoParent,
        autoplay: false, // will handle this in callback
        style: div.dataset.videoStyle,
        loop: div.dataset.videoLoop,
        events: {
          onReady: this.youtubePlayerReady.bind(this),
          onStateChange: this.youtubePlayerStateChange.bind(this),
        },
      });
    },

    // Comes from YouTube SDK
    // Get iframe ID with evt.target.getIframe().id
    // Then access product video players with videoObjects[id]
    youtubePlayerReady: function (evt) {
      var iframeId = evt.target.getIframe().id;

      if (!videoObjects[iframeId]) {
        // No youtube player data
        return;
      }

      var obj = videoObjects[iframeId];
      var player = obj.videoPlayer;

      if (obj.options.style !== "sound") {
        player.mute();
      }

      obj.parent.classList.remove("loading");
      obj.parent.classList.add("loaded");

      // If we have an element, it is in the visible/first slide,
      // and is muted, play it
      if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
        player.playVideo();
      }
    },

    _isFirstSlide: function (id) {
      return this.cache.mainSlider.querySelector(
        selectors.startingSlide + " " + "#" + id,
      );
    },

    youtubePlayerStateChange: function (evt) {
      var iframeId = evt.target.getIframe().id;
      var obj = videoObjects[iframeId];

      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (obj.attemptedToPlay) {
            obj.parent.classList.add("video-interactable");
          }
          break;
        case 0: // ended
          if (obj && obj.options.loop === "true") {
            obj.videoPlayer.playVideo();
          }
          break;
        case 3: // buffering
          obj.attemptedToPlay = true;
          break;
      }
    },

    initMp4Video: function (div) {
      videoObjects[div.id] = {
        id: div.id,
        type: "mp4",
      };

      if (this._isFirstSlide(div.id)) {
        this.playMp4Video(div.id);
      }
    },

    stopVideos: function () {
      for (var [id, vid] of Object.entries(videoObjects)) {
        if (vid.videoPlayer) {
          if (typeof vid.videoPlayer.stopVideo === "function") {
            vid.videoPlayer.stopVideo(); // YouTube player
          }
        } else if (vid.type === "mp4") {
          this.stopMp4Video(vid.id); // MP4 player
        }
      }
    },

    _getVideoType: function (video) {
      return video.getAttribute("data-video-type");
    },

    _getVideoDivId: function (video) {
      return video.id;
    },

    playMp4Video: function (id) {
      var player = this.container.querySelector("#" + id);
      var playPromise = player.play();

      if (playPromise !== undefined) {
        playPromise
          .then(function () {
            // Playing as expected
          })
          .catch(function (error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute("controls", "");
            player
              .closest(selectors.videoParent)
              .setAttribute("data-video-style", "unmuted");
          });
      }
    },

    stopMp4Video: function (id) {
      var player = this.container.querySelector("#" + id);
      if (player && typeof player.pause === "function") {
        player.pause();
      }
    },

    /*============================================================================
      Product images
    ==============================================================================*/
    initImageZoom: function () {
      var container = this.container.querySelector(
        this.selectors.imageContainer,
      );
      if (!container) {
        return;
      }
      var imageZoom = new theme.Photoswipe(container, this.sectionId);
      container.addEventListener(
        "photoswipe:afterChange",
        function (evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this),
      );
    },

    getThumbIndex: function (target) {
      return target.dataset.index;
    },

    updateVariantImage: function (evt) {
      var variant = evt.detail.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(
        variant.featured_media.preview_image.src,
        this.settings.imageSize,
      );

      var newImage = this.container.querySelector(
        '.product__thumb[data-id="' + variant.featured_media.id + '"]',
      );
      var imageIndex = this.getThumbIndex(newImage);

      // If there is no index, slider is not initalized
      if (typeof imageIndex === "undefined") {
        return;
      }

      // Go to that variant image's slide
      if (this.flickity) {
        this.flickity.goToSlide(imageIndex);
      }
    },

    initProductSlider: function (variant) {
      // Stop if only a single image, but add active class to first slide
      if (
        this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
      ) {
        var slide = this.cache.mainSlider.querySelector(selectors.slide);
        if (slide) {
          slide.classList.add("is-selected");
        }
        return;
      }

      // Destroy slider in preparation of new initialization
      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }

      // If variant argument exists, slideshow is reinitializing because of the
      // image set feature enabled and switching to a new group.
      // currentSlideIndex
      if (!variant) {
        var activeSlide = this.cache.mainSlider.querySelector(
          selectors.startingSlide,
        );
        this.settings.currentSlideIndex = this._slideIndex(activeSlide);
      }

      var mainSliderArgs = {
        adaptiveHeight: true,
        avoidReflow: true,
        initialIndex: this.settings.currentSlideIndex,
        childNav: this.cache.thumbSlider,
        childNavScroller: this.cache.thumbScroller,
        childVertical: this.cache.thumbSlider.dataset.position === "beside",
        pageDots: true, // mobile only with CSS
        wrapAround: true,
        callbacks: {
          onInit: this.onSliderInit.bind(this),
          onChange: this.onSlideChange.bind(this),
        },
      };

      // Override default settings if image set feature enabled
      if (this.settings.imageSetName) {
        var imageSetArgs = this.imageSetArguments(variant);
        mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
        this.updateImageSetThumbs(mainSliderArgs.imageSet);
      }

      this.flickity = new theme.Slideshow(
        this.cache.mainSlider,
        mainSliderArgs,
      );
    },

    onSliderInit: function (slide) {
      // If slider is initialized with image set feature active,
      // initialize any videos/media when they are first slide
      if (this.settings.imageSetName) {
        this.prepMediaOnSlide(slide);
      }
    },

    onSlideChange: function (index) {
      if (!this.flickity) return;

      var prevSlide = this.cache.mainSlider.querySelector(
        '.product-main-slide[data-index="' +
          this.settings.currentSlideIndex +
          '"]',
      );

      // If imageSetName exists, use a more specific selector
      var nextSlide = this.settings.imageSetName
        ? this.cache.mainSlider.querySelectorAll(
            ".flickity-slider .product-main-slide",
          )[index]
        : this.cache.mainSlider.querySelector(
            '.product-main-slide[data-index="' + index + '"]',
          );

      prevSlide.setAttribute("tabindex", "-1");
      nextSlide.setAttribute("tabindex", 0);

      // Pause any existing slide video/media
      this.stopMediaOnSlide(prevSlide);

      // Prep next slide video/media
      this.prepMediaOnSlide(nextSlide);

      // Update current slider index
      this.settings.currentSlideIndex = index;
    },

    stopMediaOnSlide(slide) {
      // Stop existing video
      var video = slide.querySelector(selectors.productVideo);
      if (video) {
        var videoType = this._getVideoType(video);
        var videoId = this._getVideoDivId(video);
        if (videoType === "youtube") {
          if (videoObjects[videoId].videoPlayer) {
            videoObjects[videoId].videoPlayer.stopVideo();
            return;
          }
        } else if (videoType === "mp4") {
          this.stopMp4Video(videoId);
          return;
        }
      }

      // Stop existing media
      var currentMedia = slide.querySelector(this.selectors.media);
      if (currentMedia) {
        currentMedia.dispatchEvent(
          new CustomEvent("mediaHidden", {
            bubbles: true,
            cancelable: true,
          }),
        );
      }
    },

    prepMediaOnSlide(slide) {
      var video = slide.querySelector(selectors.productVideo);
      if (video) {
        this.flickity.reposition();
        var videoType = this._getVideoType(video);
        var videoId = this._getVideoDivId(video);
        if (videoType === "youtube") {
          if (
            videoObjects[videoId].videoPlayer &&
            videoObjects[videoId].options.style !== "sound"
          ) {
            videoObjects[videoId].videoPlayer.playVideo();
            return;
          }
        } else if (videoType === "mp4") {
          this.playMp4Video(videoId);
        }
      }

      var nextMedia = slide.querySelector(this.selectors.media);
      if (nextMedia) {
        nextMedia.dispatchEvent(
          new CustomEvent("mediaVisible", {
            bubbles: true,
            cancelable: true,
          }),
        );
        slide
          .querySelector(".shopify-model-viewer-ui__button")
          .setAttribute("tabindex", 0);
        slide
          .querySelector(".product-single__close-media")
          .setAttribute("tabindex", 0);
      }
    },

    _slideIndex: function (el) {
      return el.getAttribute("data-index");
    },

    /*============================================================================
      Products when in quick view modal
    ==============================================================================*/
    openModalProduct: function () {
      var initialized = false;

      if (!this.settings.modalInit) {
        this.blocksHolder = this.container.querySelector(
          selectors.blocksHolder,
        );
        var url = this.blocksHolder.dataset.url;

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var blocks = doc.querySelector(selectors.blocks);

              // Because the same product could be opened in quick view
              // on the page we load the form elements from, we need to
              // update any `id`, `for`, and `form` attributes
              blocks.querySelectorAll("[id]").forEach((el) => {
                // Update input `id`
                var val = el.getAttribute("id");
                el.setAttribute("id", val + "-modal");

                // Update related label if it exists
                var label = blocks.querySelector(`[for="${val}"]`);
                if (label) {
                  label.setAttribute("for", val + "-modal");
                }

                // Update any collapsible elements
                var collapsibleTrigger = blocks.querySelector(
                  `[aria-controls="${val}"]`,
                );
                if (collapsibleTrigger) {
                  collapsibleTrigger.setAttribute(
                    "aria-controls",
                    val + "-modal",
                  );
                }
              });

              // Update any elements with `form` attribute.
              // Form element already has `-modal` appended
              var form = blocks.querySelector(this.selectors.form);
              var formId = form.getAttribute("id");
              blocks.querySelectorAll("[form]").forEach((el) => {
                el.setAttribute("form", formId);
              });

              this.blocksHolder.innerHTML = "";
              this.blocksHolder.append(blocks);
              this.blocksHolder.classList.add("product-form-holder--loaded");

              this.cacheElements();

              this.formSetup();
              this.updateModalProductInventory();

              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }

              // Re-hook up collapsible box triggers
              theme.collapsibles.init(this.container);

              document.dispatchEvent(
                new CustomEvent("quickview:loaded", {
                  detail: {
                    productId: this.sectionId,
                  },
                }),
              );
            }.bind(this),
          );

        this.productSetup();
        this.videoSetup();

        // Enable product slider in quick view
        // 1. with image sets enabled, make sure we have this.variants before initializing
        // 2. initialize normally, form data not required
        if (this.settings.imageSetName) {
          if (this.variants) {
            this.initProductSlider();
          } else {
            document.addEventListener(
              "quickview:loaded",
              function (evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this),
            );
          }
        } else {
          this.initProductSlider();
        }
        this.customMediaListners();
        this.addIdToRecentlyViewed();
        this.settings.modalInit = true;
      } else {
        initialized = true;
      }

      AOS.refreshHard();

      document.dispatchEvent(
        new CustomEvent("quickview:open", {
          detail: {
            initialized: initialized,
            productId: this.sectionId,
          },
        }),
      );
    },

    // Recommended products load via JS and don't add variant inventory to the
    // global variable that we later check. This function scrapes a data div
    // to get that info and manually add the values.
    updateModalProductInventory: function () {
      window.inventories = window.inventories || {};
      this.container
        .querySelectorAll(".js-product-inventory-data")
        .forEach((el) => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
            window.inventories[productId][el.dataset.id] = {
              quantity: el.dataset.quantity,
              policy: el.dataset.policy,
              incoming: el.dataset.incoming,
              next_incoming_date: el.dataset.date,
            };
          });
        });
    },

    closeModalProduct: function () {
      this.stopVideos();
    },

    /*============================================================================
      Product media (3D)
    ==============================================================================*/
    initModelViewerLibraries: function () {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.media,
      );
      if (modelViewerElements.length < 1) return;

      theme.ProductMedia.init(modelViewerElements, this.sectionId);
    },

    initShopifyXrLaunch: function () {
      document.addEventListener(
        "shopify_xr_launch",
        function () {
          var currentMedia = this.container.querySelector(
            this.selectors.productMediaWrapper +
              ":not(." +
              self.classes.hidden +
              ")",
          );
          currentMedia.dispatchEvent(
            new CustomEvent("xrLaunch", {
              bubbles: true,
              cancelable: true,
            }),
          );
        }.bind(this),
      );
    },

    customMediaListners: function () {
      document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
        el.addEventListener(
          "click",
          function () {
            var slide = this.cache.mainSlider.querySelector(
              selectors.currentSlide,
            );
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent("mediaHidden", {
                  bubbles: true,
                  cancelable: true,
                }),
              );
            }
          }.bind(this),
        );
      });

      var modelViewers = this.container.querySelectorAll("model-viewer");
      if (modelViewers.length) {
        modelViewers.forEach((el) => {
          el.addEventListener(
            "shopify_model_viewer_ui_toggle_play",
            function (evt) {
              this.mediaLoaded(evt);
            }.bind(this),
          );

          el.addEventListener(
            "shopify_model_viewer_ui_toggle_pause",
            function (evt) {
              this.mediaUnloaded(evt);
            }.bind(this),
          );
        });
      }
    },

    mediaLoaded: function (evt) {
      this.container
        .querySelectorAll(this.selectors.closeMedia)
        .forEach((el) => {
          el.classList.remove(classes.hidden);
        });

      if (this.flickity) {
        this.flickity.setDraggable(false);
      }
    },

    mediaUnloaded: function (evt) {
      this.container
        .querySelectorAll(this.selectors.closeMedia)
        .forEach((el) => {
          el.classList.add(classes.hidden);
        });

      if (this.flickity) {
        this.flickity.setDraggable(true);
      }
    },

    onUnload: function () {
      theme.ProductMedia.removeSectionModels(this.sectionId);

      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }
    },
  });

  return Product;
})();

theme.reinitProductGridItem = function (scope) {
  if (AOS) {
    AOS.refreshHard();
  }

  theme.lazyImages();
  theme.initQuickShop();

  // Refresh reviews app
  if (window.SPR) {
    SPR.initDomEls();
    SPR.loadBadges();
  }

  // Re-hook up collapsible box triggers
  theme.collapsibles.init();
};

/*============================================================================
  Things that don't require DOM to be ready
==============================================================================*/
theme.config.hasSessionStorage = theme.isStorageSupported("session");
theme.config.hasLocalStorage = theme.isStorageSupported("local");
AOS.init({
  easing: "ease-out-quad",
  once: true,
  offset: 60,
  disableMutationObserver: true,
});

if (theme.config.hasLocalStorage) {
  theme.recentlyViewed.localStorage =
    window.localStorage.getItem("theme-recent");

  if (theme.recentlyViewed.localStorage) {
    theme.recentlyViewed.recent = JSON.parse(
      theme.recentlyViewed.localStorage,
    );
  }
}

theme.recentlyViewed.productInfo =
  theme.config.hasSessionStorage && sessionStorage["recent-products"]
    ? JSON.parse(sessionStorage["recent-products"])
    : {};

// Trigger events when going between breakpoints
theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
  if (mql.matches) {
    theme.config.bpSmall = true;
    document.dispatchEvent(new CustomEvent("matchSmall"));
  } else {
    theme.config.bpSmall = false;
    document.dispatchEvent(new CustomEvent("unmatchSmall"));
  }
});

/*============================================================================
  Things that require DOM to be ready
==============================================================================*/
theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSize) {
  var output = "";

  items.forEach((product) => {
    var image = theme.buildProductImage(product, imageSize);
    var markup = `
      <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
        <div class="grid-product__content">
          <a href="${product.url}" class="grid-product__link">
            <div class="grid-product__image-mask">
              ${image}
            </div>
            <div class="grid-product__meta">
              <div class="grid-product__title">${product.title}</div>
            </div>
          </a>
        </div>
      </div>
    `;

    output += markup;
  });

  return output;
};

theme.buildProductImage = function (product, imageSize) {
  var size = imageSize ? imageSize : theme.settings.productImageSize;
  var output = "";
  var sizes = "(min-width: 769px) 25vw, 50vw";
  var src = product.image_responsive_url
    ? product.image_responsive_url.replace("{width}", 540)
    : "";

  if (size === "natural") {
    var srcset = theme.Images.buildSrcset(product.image_responsive_url, [
      180, 360, 540, 720, 900,
    ]);
    output = `
      <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
        <img class="grid-product__image js-lazyimage"
          src="${src}"
          srcset="${srcset}"
          sizes="${sizes}"
          loading="lazy"
          alt="${product.title}">
      </div>`;
  } else {
    var classes = "js-lazyimage";
    if (!theme.settings.productImageCover) {
      classes += " grid__image-contain";
    }
    var srcset2 = theme.Images.buildSrcset(product.image_responsive_url, [
      360, 540, 720, 900, 1080,
    ]);
    output = `
      <div class="grid__image-ratio grid__image-ratio--${size}">
        <img class="${classes}"
            src="${src}"
            srcset="${srcset2}"
            sizes="${sizes}"
            loading="lazy"
            alt="${product.title}">
      </div>
    `;
  }

  return output;
};

